import { render, staticRenderFns } from "./Classroom_list_video.vue?vue&type=template&id=1c006a24&scoped=true"
import script from "./Classroom_list_video.vue?vue&type=script&lang=js"
export * from "./Classroom_list_video.vue?vue&type=script&lang=js"
import style0 from "./Classroom_list_video.vue?vue&type=style&index=0&id=1c006a24&prod&scoped=true&lang=less"
import style1 from "./Classroom_list_video.vue?vue&type=style&index=1&id=1c006a24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c006a24",
  null
  
)

export default component.exports